import type { ClaimReviewStepData } from '@/types';
import sharedClaimReviewStepData from '@data-shared/newClaim/claimReviewStep';

const claimReviewStepData: ClaimReviewStepData = {
  ...sharedClaimReviewStepData,
};

export default claimReviewStepData;
